import firebase from "firebase";

const firebaseConfig = {
    apiKey: "AIzaSyB6Nw7Wm8yfEzW6zdFH-aiDGIKgcNUPBdw",
    authDomain: "hack98denim.firebaseapp.com",
    projectId: "hack98denim",
    storageBucket: "hack98denim.firebasestorage.app",
    messagingSenderId: "364771788190",
    appId: "1:364771788190:web:e8a9de0008d382cfd7428f",
    measurementId: "G-Q5DM6TFP4Z"
};
firebase.initializeApp(firebaseConfig);

var db = firebase.firestore();
var auth = firebase.auth();

export { db, auth }